module.exports = __webpack_public_path__ + "img/475.f248fe5c.jpg";